module.exports = __webpack_public_path__ + "img/payment_pc_11.3933112a.png";